import { createSlice } from '@reduxjs/toolkit';
import { getCoursesOfStudent, getDetailCourse, getCourseUpcoming, getModulesOfCourse, getCourses, getCoursesDetailOfStudent } from './courseThunk';
import { ICourse, ICoursesDetail } from '~/utils/interface/course';
import { IModule } from '~/utils/interface/course';
import { DEFAULT_PAGE } from '~/utils/constants/common';

interface CourseState {
  courses: ICourse[];
  availableLessons: IModule[];
  scheduledLessons: IModule[];
  coursesDetail: ICoursesDetail;
  currentPage: number;
  hasMore: boolean;
  isLoading: boolean;
  errorMessage?: string;
}

const initialState: CourseState = {
  courses: [],
  availableLessons: [],
  scheduledLessons: [],
  coursesDetail: {} as ICoursesDetail,
  currentPage: DEFAULT_PAGE,
  hasMore: false,
  isLoading: false,
};

const courseSlice = createSlice({
  name: 'courseSlice',
  initialState,
  reducers: {
    setNewCourses(state, action) {
      state.courses = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Get Courses Upcoming
    builder
      .addCase(getCourseUpcoming.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = undefined;
      })
      .addCase(getCourseUpcoming.fulfilled, (state, action) => {
        const coursesData: IModule[] = action.payload.data;
        const today = new Date();
        const futureCourses = coursesData
          .filter((item) => !item.date || (item.date && new Date(item.date) > today))
          .sort((a, b) => {
            if (!a.date && !b.date) return 0;
            if (!a.date) return 1;
            if (!b.date) return -1;
            return new Date(a.date).getTime() - new Date(b.date).getTime();
          });

        state.scheduledLessons = futureCourses;
        state.availableLessons = coursesData.filter((c) => !futureCourses.includes(c));
        state.isLoading = false;
        state.errorMessage = undefined;
      })
      .addCase(getCourseUpcoming.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
      });

    // Get Detail Courses
    builder
      .addCase(getDetailCourse.pending, (state) => {})
      .addCase(getDetailCourse.fulfilled, (state, action) => {
        state.coursesDetail = action.payload.data;
      })
      .addCase(getDetailCourse.rejected, (state) => {});

    // Get List Courses Of Student
    builder
      .addCase(getCoursesOfStudent.pending, (state) => {})
      .addCase(getCoursesOfStudent.fulfilled, (state) => {})
      .addCase(getCoursesOfStudent.rejected, (state) => {});

    // Get List Modules Of Course
    builder
      .addCase(getModulesOfCourse.pending, (state) => {})
      .addCase(getModulesOfCourse.fulfilled, (state) => {})
      .addCase(getModulesOfCourse.rejected, (state) => {});

    // Get Courses
    builder
      .addCase(getCourses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCourses.fulfilled, (state, action) => {
        state.courses = action.payload.data.responses;
        state.isLoading = false;
        state.currentPage = +action.payload.data.currentPage;
        state.hasMore = action.payload.data.hasMore;
      })
      .addCase(getCourses.rejected, (state) => {
        state.isLoading = true;
      });
    // Get Courses Detail Of Student
    builder
      .addCase(getCoursesDetailOfStudent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCoursesDetailOfStudent.fulfilled, (state, action) => {
        state.coursesDetail = action.payload.data;
        state.isLoading = false;
      })
      .addCase(getCoursesDetailOfStudent.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

// Actions
export const courseAction = courseSlice.actions;

// Reducer
const courseReducer = courseSlice.reducer;
export default courseReducer;
